module.exports = __webpack_public_path__ + "static/media/7.b2dd5860.jpg";